import { useState } from 'react';
import './styles/loginSignup.css';
import Login from './login';
import Register from './Register';

export default function () {
  const [register, setRegister] = useState(false);

  return (
    <div className="popupWrapper">
      {register ? (
        <Register setRegister={setRegister} register={register} />
      ) : (
        <Login setRegister={setRegister} register={register} />
      )}
    </div>
  );
}
